import React, { useEffect, useState } from 'react';
import apiService from '../../../Services/apiServices';

const AtkSaleBookHeader = () => {

    const [vat0, setVat0] = useState([]);
    const [vat18, setVat18] = useState([]);
    const [vat8, setVat8] = useState([]);
    const [filledTable, setFilledTable] = useState(false);

    const getData = async () => {
        const params = `purchaseOrSale=${1}`;

        await apiService().query('getSaleOrPurchase', params)
            .then((response) => {
                if (response.success) {
                    const d = response.data;
                    let vat0Array = d.filter(f => f.vat === 0)
                    const newObject = { number: '10', name: 'Totali i shitjeve të liruara me të drejtë kreditimi', vat: 0}
                    let insertIndex = vat0Array.findIndex(item => parseInt(item?.number) > 10)
                    if (insertIndex !== -1) {
                        vat0Array.splice(insertIndex, 0, newObject);
                    }
                    setVat0(vat0Array);
                    setVat18(d.filter(f => f.vat === 18));
                    setVat8(d.filter(f => f.vat === 8));
                    setFilledTable(true);
                }
            });
    }

    useEffect(() => {
        
        getData();
    }, []);

    return (
        <tbody>
            <tr height="34" style={{textAlign: 'center', lineHeight: 1, fontSize: '10pt', fontFamily: 'Arial', fontWeight: 'bold'}}>
                <td height="34" width="39.20" style={{border:'1.0pt solid #000'}} rowSpan={2}>Nr</td>
                <td width="192" style={{border:'1.0pt solid #000'}} colspan="2" >Fatura</td>
                <td width="355.93" colspan="3" style={{border:'1.0pt solid #000'}}>Blerësi</td>
                <td width={vat0.length * 80} colSpan={vat0.length } style={{border:'1.0pt solid #000'}}>Shitjet e liruara nga TVSH</td>
                <td width={vat18.length * 80} colSpan={vat18.length + 1} style={{border:'1.0pt solid #000'}}>Shitjet e tatueshme me norm&#xEB;n 18%</td>
                <td width={vat8.length * 80} colSpan={vat8.length + 1} style={{border:'1.0pt solid #000'}}>Shitjet e tatueshme me norm&#xEB;n 8%</td>
                <td width="95.93" rowSpan={2} style={{border:'1.0pt solid #000', background: '#BFBFBF'}}>Totali i TVSH-se se zbritshme me 18% dhe 8%</td>
            </tr>
            <tr style={{height: '97px', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial'}}>
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Data</td>
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Numri i fatures</td>
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Emri i bler&#xEB;sit</td>
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Numri fiskal i bler&#xEB;sit</td>
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Numri i TVSH-se se bler&#xEB;sit</td>
                {vat0.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                {vat18.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0, backgroundColor: '#CFFFD3' }}>Totali i TVSH-se se zbritshme me 18%</td>
                {vat8.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                <td style={{border:'1.0pt solid #000', padding: 0, marggin: 0}}>Totali i TVSH-s&#xEB; s&#xEB; llogaritur me norm&#xEB;n 8%</td>
            </tr>
            <tr style={{color: 'black', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial'}}>
                <td style={{border:'1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0}} colSpan={6}>Numri i kutise ne deklaraten e TVSH-se</td>
                {vat0.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 , background: item?.number === '10' && '#BFBFBF' }}>{item.number}</td>
                ))}
                {vat18.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.number}</td>
                ))}
                                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[K1]</td>
                {vat8.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.number}</td>
                ))}
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[K2]</td>
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[30]</td>
            </tr>
        </tbody>
    )
};

export default AtkSaleBookHeader;
